import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Collaborate with TekRevol in Texas for Business Digitalization
            </h2>
            <p>
              Our tailored digital solutions are crafted with accuracy to
              seamlessly line up with your business objectives. At Tekrevol, we
              recognize the emerging technologies that need expert guidance to
              transform ideas into impactful realities. With our deep
              understanding of technology and business, we'll help you identify
              bottlenecks, enhance workflows, and implement solutions that
              optimize your operations. Whether it's automating processes,
              integrating systems, or leveraging data insights, we're your
              partners in unlocking new levels of productivity and
              profitability.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
